$(function () {
    var blockWrapper = $(".country-selector-wrapper");
    if (blockWrapper.length) {
        $(".country-selector-wrapper").simpleFilter();
    }
});